<template>
  <div :style='style'
       class='text-white bg-white absolute opacity-50 border-solid border-black border-2'
       :class='heightClass'>
    <hammer-pannable v-model='center'
                     class="text-black h-full"
                     :bounds-checker='boundsChecker'
                     >
      <arrow-split-vertical :size='16' />
    </hammer-pannable>
  </div>
</template>
<script>
import ArrowSplitVertical from '@icons/ArrowSplitVertical.vue';
import HammerPannable from '@ui/atoms/HammerPannable.vue';
export default {
  props: {
    value: {
      type: Number,
      required: true
    },
    duration: {
      type: Number,
      required: true
    },
    windowDuration: {
      type: Number,
      required: true
    },
    heightClass: {
      type: String,
      required: true
    },
    timelineElementWidth: {
      type: Number,
      required: true
    }
  },
  components: {
    ArrowSplitVertical,
    HammerPannable
  },
  methods: {
    boundsChecker(nv) {
      let t = this.convertPixelsToTime(nv);
      const valid = t >= this.windowDuration/2 && t <= (this.duration - this.windowDuration/2);
      if (valid) {
        return {valid}
      } else {
        let v;
        if (t < this.windowDuration/2) {
          v = this.windowDuration/2;
        } else {
          v = this.duration - this.windowDuration/2;
        }
        return {
          valid,
          v: this.convertTimeToPixels(v)
        }
      }
    },
    convertPixelsToTime(nv) {
      return nv / this.timelineElementWidth * this.duration;
    },
    convertTimeToPixels(nv) {
      return (nv * this.timelineElementWidth) / this.duration;
    }
  },
  computed:{
    style() {
      const begin = ((this.value - this.windowDuration / 2) / this.duration * 100).toFixed(2) + '%';
      const width = (this.windowDuration / this.duration * 100).toFixed(2) + '%';
      return {
          'left':begin,
          'top':'0px',
          'width':width
        }
    },
    center: {
      set(nv) {
        //const newValue = (nv / this.timelineElementWidth * this.duration) + this.windowDuration / 2;
        const newValue = this.convertPixelsToTime(nv)
        this.$emit('input', newValue);
      },
      get() {
        return (this.value) / this.duration * this.timelineElementWidth;
        //return this.convertPixelsToTime(this.value) + this.windowDuration / 2;
      }
    }
  }
}
</script>

